import axios from 'axios';
import { snackbar } from './snackbarService';

const AxiosEnviar = async (url, data, method = 'POST', confirmacion = false) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios({
      url: `${process.env.REACT_APP_API_URL}${url}`,
      method: method,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (confirmacion) {
      const msg = typeof response.data === 'string'
        ? response.data
        : response.data?.message ?? 'Operación realizada correctamente';
      snackbar.success(msg);
    }

    return response.data;

  } catch (error) {
    if (error.response?.data) {
      const errorMessage = error.response.data.message || "Ocurrió un error desconocido.";
      snackbar.error(`Error: ${errorMessage}`);
    } else {
      snackbar.error("Error: No se pudo conectar al servidor. Intenta nuevamente.");
    }
  }
};

export default AxiosEnviar;
